<template>
  <div>
    <nav-breadcrumb :menu="[{label: userId ? '编辑渠道商用户' : '新增渠道商用户'}]"/>

    <el-row>
      <el-col>
        <panel>
          <el-form :model="dealerUserForm" :rules="dealerUserFormRules" ref="dealerUserForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">


              <el-col :span="24">
                <el-form-item label="姓名：" prop="du__userName"  :rules="{required: true, message: '姓名不能为空'}" style="width: 27%">
                  <el-input v-model="dealerUserForm.du__userName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="身份证号：" prop="du__IC" :rules="{required: true, message: '身份证号不能为空'}" style="width: 40%">
                  <el-input v-model="dealerUserForm.du__IC" maxlength="18"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="渠道商：" prop="du__dealerId" :rules="{required: true, message: '渠道商不能为空'}" style="width: 27%">
                  <el-select placeholder="请选择渠道商" v-model.trim="dealerUserForm.du__dealerId" filterable>
                    <el-option :label="item.label" :value="item.value" v-for="(item,idx) in dealerOptions" :key="idx"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="手机号：" prop="du__mobileNo"  :rules="{required: true, message: '手机号不能为空'}" style="width: 27%">
                  <el-input v-model="dealerUserForm.du__mobileNo" maxlength="11"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="角色：" prop="r__roleName" :rules="{required: true, message: '角色不能为空'}" style="width: 27%">
                  <el-select placeholder="请选择角色" v-model.trim="dealerUserForm.r__roleName" >
                    <el-option :label="item.label" :value="item.value" v-for="(item,idx) in roleOptions" :key="idx"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="状态：" prop="du__disabled" :rules="{required: true, message: '状态不能为空'}" style="width: 27%">
                  <el-select placeholder="请选择状态" v-model.trim="dealerUserForm.du__disabled" >
                    <el-option :label="item.label" :value="item.value" v-for="(item,idx) in disabledOptions" :key="idx"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
                <el-col :span="24">
                    <el-form-item label="关联渠道商：" prop="a__dealerId" style="width: 27%">
                        <el-select placeholder="请选择渠道商" v-model.trim="dealerUserForm.a__dealerId" filterable clearable>
                            <el-option :label="item.label" :value="item.value" v-for="(item,idx) in dealerOptions2" :key="idx"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
          </el-form>
        </panel>
      </el-col>
    </el-row>
    <div class="tr xzmt">
      <el-button type="primary" @click="onSubmit('dealerUserForm')">确认提交</el-button>
      <el-button @click="$router.back()">取消</el-button>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
    export default {
        name: "DealerUserAdd",
      data(){
          return {
            userId: this.$route.query['userId']||'',
            dealerUserForm:{
              r__roleName:'',
              du__disabled:'N',
                a__dealerId:'',
              detail:[
                {
                  detail__checked: true,
                  r__role:'',
                }
              ],
              affiliates:[
                    {
                        affiliates__checked: false,
                        a__dealerId:'',
                    }
                ]
            },
            dealerOptions : [],
            dealerOptions2:[],
            roleOptions: [
              {
                label:'渠道商 进件',
                value:'渠道商 进件',
              },
              {
                label:'渠道商 初审',
                value:'渠道商 初审',
              },
              {
                label:'渠道商 内勤',
                value:'渠道商 内勤',
              }
            ],

            disabledOptions:[
              {
                label:'启用',
                value:'N'
              },
              {
                label:'禁用',
                value:'Y'
              },
            ],
            dealerUserFormRules: {},
          }
      },
        watch: {
            'dealerUserForm.du__dealerId': function () {
                this.getDealer2List()
            }
        },
      mounted() {
        if(this.userId){
          this.getData()
        }
        this.getDealerList()
      },
      methods:{
        getData:function(){
          xhr.getDealerUser({
              'du.userId': this.userId
            },
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.dealerUserForm = Object.assign({}, res.data.data, {
                    r__roleName: res.data.data.detail[0].r__role,
                      a__dealerId: res.data.data.affiliates[0].a__dealerId

                  })
                }
              }catch (e) {

              }
            })
        },
        getDealerList: function () {
          xhr.getDealerList(
            Object.assign({pageSize:0}, {}, {}),
            res=> {
              try {
                this.dealerOptions = res.data.data.map(item=>{
                  return {
                    label: item.d__dealerName,
                    value:item.d__dealerId,
                  }
                })
              }catch(e){

              }
            })

        },
          getDealer2List: function () {
              xhr.getDealerList(
                  Object.assign({
                      'xlist.search.d.dealerId':this.dealerUserForm.du__dealerId,
                      'xlist.search.d.dealerId.op':'neq',

                      pageSize:0}, {}, {}),
                  res=> {
                      try {
                          this.dealerOptions2 = res.data.data.map(item=>{
                              return {
                                  label: item.d__dealerName,
                                  value:item.d__dealerId,
                              }
                          })
                      }catch(e){

                      }
                  })

          },
        onSubmit: function (formName) {

          this.dealerUserForm.detail = [
            {
              detail__checked: true,
              r__role:this.dealerUserForm.r__roleName,
            }
          ]
            this.dealerUserForm.affiliates = [
                {
                    a__checked: this.dealerUserForm.a__dealerId?true:false,
                    a__dealerId:this.dealerUserForm.a__dealerId,
                }
            ]
          let dealerUserForm = this.dealerUserForm
          this.$refs[formName].validate(valid=> {
            if (valid) {
              dealerUserForm.du__checked = true
              xhr.updateDealerUser(dealerUserForm, res=> {
                try {
                  if (res.data.status == 'success') {
                    this.$router.push({
                      name: 'DealerUserListView'
                    })
                  }
                } catch (e) {
                }
              })
            }
          })
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/DealerUserAdd.vue